<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM6.50001 12.4143L13.2071 5.70718L11.7929 4.29297L6.50001 9.58586L4.70712 7.79297L3.29291 9.20718L6.50001 12.4143Z"
    fill="currentColor"
  />
</svg>
